import * as React from 'react';
import { Component } from 'react';
import parser from 'fast-xml-parser';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Grid from '@material-ui/core/Grid';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import ToggleButton from '@material-ui/lab/ToggleButton';
import FormControl from '@material-ui/core/FormControl';
import { TextValidator } from 'react-material-ui-form-validator';
import CircularProgress from '@material-ui/core/CircularProgress';
import AddressDropDown from '../DropDowns/AddressDropDown';
import AddressSelectorViewModel from '../ViewModels/AddressSelectorViewModel';
//import AFDPostcodeResult from '../ViewModels/AFDPostcodeResult';
import AFDPostcodeResultDetail from '../ViewModels/AFDPostcodeResultDetail';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/SearchRounded'
import Input from '@material-ui/core/Input'
import Grow from '@material-ui/core/Grow';


const styles = (theme: Theme) => createStyles({
    error: {
        color: "#FF0000",
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    iconButton: {
        padding: 10,

    },
    container: {
        marginTop: '20px;',
        marginBottom: '20px;',
    },
    toggleButton: {
         width:'100%',
    },
    toggleButtonGroup: {
        width: '100%',
    }
});


interface IAddressProps {
    title: string;
    setAddress: (address: AddressSelectorViewModel) => void;
    postcodeProp: string;
    postcodeOutProp: string;
    postcodeInProp: string;
    address1Prop: string;
    address2Prop: string;
    address3Prop: string;
    address4Prop: string;
    addressPostcodeLabel: string;
    address1Label: string;
    address2Label: string;
    address3Label: string;
    address4Label: string;

    setShowTimeAtAddress?: (newState: boolean) => void;
}

interface IAddressState {
    model: AddressSelectorViewModel;
    loadingAddress: boolean;
    afdResults: AFDPostcodeResultDetail[];
    overseasAddress: boolean;
}

class Address extends Component<IAddressProps & WithStyles<typeof styles>, IAddressState> {
    constructor(props) {
        super(props);
        this.state = {
            model: new AddressSelectorViewModel,
            loadingAddress: false,
            afdResults: [],
            overseasAddress: false,
        }
    }

    componentDidMount() {
        if (this.props.setShowTimeAtAddress !== undefined && this.props.setShowTimeAtAddress !== null) {
            this.props.setShowTimeAtAddress(true);
        }
    }

    public render() {

        return (
            <Grid container spacing={1} className={this.props.classes.container}>
                <Grid item xs={12}>
                    <Typography variant="h4">
                        {this.props.title}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <ToggleButtonGroup
                        value={this.state.overseasAddress}
                        exclusive

                        onChange={this.handleOverseasChange}
                        aria-label="Overseas address"
                        className={this.props.classes.toggleButtonGroup}
                        
                    >
                        <ToggleButton value={false} aria-label="UK address" className={this.props.classes.toggleButton}>
                            UK Address
                        </ToggleButton>
                        <ToggleButton value={true} aria-label="Non-UK Address" className={this.props.classes.toggleButton}>
                            Non-UK Address
                        </ToggleButton>

                    </ToggleButtonGroup>
                </Grid>

                {this.state.overseasAddress === false &&
                    <React.Fragment>
                        <Grid item xs={12}>
                            <Input type="hidden" name={this.props.postcodeInProp} value={this.state.model.postcodeIn} />
                            <Input type="hidden" name={this.props.postcodeOutProp} value={this.state.model.postcodeOut} />
                            <FormControl fullWidth>
                                <TextValidator
                                    label={this.props.addressPostcodeLabel}
                                    name={this.props.postcodeProp}
                                    fullWidth
                                    variant="outlined"
                                    margin="normal"
                                    value={this.state.model.postcode}
                                    onChange={this.handlePostcodeChange}
                                    validators={['isPSValid', 'required']}
                                    errorMessages={['Please enter a valid postcode UK Postcode, in the following format: AA11 1AA', 'This field is required']}
                                    InputProps={{
                                        endAdornment:
                                            <InputAdornment position="end">
                                                {this.state.loadingAddress && <CircularProgress color='secondary' size={24} className={this.props.classes.buttonProgress} />}
                                                {!this.state.loadingAddress && <Button onClick={this.loadAddress} color="primary" variant="contained" fullWidth endIcon={<SearchIcon />}>
                                                    Find Address
                                            </Button>}




                                            </InputAdornment>,
                                    }}
                                />






                            </FormControl>
                        </Grid>


                    </React.Fragment>
                }

                {this.state.afdResults !== undefined && (this.state.afdResults.length === undefined || this.state.afdResults.length > 0) &&
                    <Grow in={this.state.afdResults !== undefined && this.state.afdResults.length > 0}>
                        <Grid item xs={12}>
                            <AddressDropDown
                                address={this.state.model.addressIndex}
                                disabled={false}
                                model={this.state.afdResults}
                                setAddress={this.setAddress}

                            />
                        </Grid>
                    </Grow>
                }

                <React.Fragment>
                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <TextValidator
                                label={this.props.address1Label}
                                name={this.props.address1Prop}
                                fullWidth
                                variant="outlined"
                                margin="normal"
                                value={this.state.model.address1}
                                onChange={this.handleAddress1Change}
                                validators={['required']}
                                errorMessages={['This field is required']}
                                inputProps={{
                                    readOnly: this.state.overseasAddress !== true
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <TextValidator
                                label={this.props.address2Label}
                                name={this.props.address2Prop}
                                fullWidth
                                variant="outlined"
                                margin="normal"
                                value={this.state.model.address2}
                                onChange={this.handleAddress2Change}
                                inputProps={{
                                    readOnly: this.state.overseasAddress !== true
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <TextValidator
                                label={this.props.address3Label}
                                name={this.props.address3Prop}
                                fullWidth
                                variant="outlined"
                                margin="normal"
                                value={this.state.model.address3}
                                onChange={this.handleAddress3Change}
                                validators={['required']}
                                errorMessages={['This field is required']}
                                inputProps={{
                                    readOnly: this.state.overseasAddress !== true
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            
                            <TextValidator
                                label={this.props.address4Label}
                                name={this.props.address4Prop}
                                fullWidth
                                variant="outlined"
                                margin="normal"
                                value={this.state.model.address4}
                                onChange={this.handleAddress4Change}
                                //validators={['required']}
                                errorMessages={['This field is required']}
                                inputProps={{
                                    readOnly: this.state.overseasAddress !== true
                                }}
                            />
                        </FormControl>
                    </Grid>
                </React.Fragment>
                

            </Grid>
        );
    }

    private handleOverseasChange = (event, newAlignment) => {
        if (newAlignment !== null) {
            let newModel = this.state.model;
            newModel.postcode = '';
            newModel.address1 = '';
            newModel.address2 = '';
            newModel.address3 = '';
            newModel.address4 = '';
            this.setState({ overseasAddress: newAlignment, model: newModel });

            if (this.props.setShowTimeAtAddress !== undefined && this.props.setShowTimeAtAddress !== null) {
                this.props.setShowTimeAtAddress(!newAlignment);
            }
        }
    };

    private handlePostcodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const currModel: AddressSelectorViewModel = this.state.model;
        currModel.postcode = event.target.value;

        if (event.target.value.split(' ')[0] !== undefined) {
            currModel.postcodeOut = event.target.value.split(' ')[0]
        }
        if (event.target.value.split(' ')[1] !== undefined) {
            currModel.postcodeIn = event.target.value.split(' ')[1]
        }

        this.setState({ model: currModel }, () => this.props.setAddress(currModel));
    }

    private handleAddress1Change = (event: React.ChangeEvent<HTMLInputElement>) => {
        const currModel: AddressSelectorViewModel = this.state.model;
        currModel.address1 = event.target.value;

        this.setState({ model: currModel }, () => this.props.setAddress(currModel));
    }

    private handleAddress2Change = (event: React.ChangeEvent<HTMLInputElement>) => {
        const currModel: AddressSelectorViewModel = this.state.model;
        currModel.address2 = event.target.value;

        this.setState({ model: currModel }, () => this.props.setAddress(currModel));
    }

    private handleAddress3Change = (event: React.ChangeEvent<HTMLInputElement>) => {
        const currModel: AddressSelectorViewModel = this.state.model;
        currModel.address3 = event.target.value;

        this.setState({ model: currModel }, () => this.props.setAddress(currModel));
    }

    private handleAddress4Change = (event: React.ChangeEvent<HTMLInputElement>) => {
        const currModel: AddressSelectorViewModel = this.state.model;
        currModel.address4 = event.target.value;

        this.setState({ model: currModel }, () => this.props.setAddress(currModel));
    }

    public clearAddress = () => {
        let newModel: AddressSelectorViewModel = this.state.model;
        newModel.addressIndex = undefined;
        newModel.address1 = '';
        newModel.address2 = '';
        newModel.address3 = '';
        newModel.address4 = '';

        this.setState({ model: newModel }, () => this.props.setAddress(newModel));
    }

    private loadAddress = () => {
        this.clearAddress();

        if (this.state.model.postcode !== undefined && this.state.model.postcode.length !== undefined && this.state.model.postcode.length > 0) {
            fetch('https://pce.afd.co.uk/afddata.pce?Serial=826449&Password=zhvOmSsO&UserID=HULLC01&Data=Address&Task=FastFind&Fields=Standard&Lookup=' + this.state.model.postcode)
                .then(response => response.text()).then((data) => {
                    
                    let addresses = parser.parse(data);
                    let addressesWithType = addresses.AFDPostcodeEverywhere;//: AFDPostcodeResult
                    
                    if (addressesWithType.Item !== undefined && addressesWithType.Item.length) {
                        this.setState({
                            afdResults: addressesWithType.Item
                        });
                    } else if (addressesWithType.Item !== undefined) {
                        if (addressesWithType.Item[0] !== null && addressesWithType.Item !== undefined)
                        this.setState({
                            afdResults: [addressesWithType.Item]
                        });
                    }
                });
        }
    }

    public setAddress = (address: AFDPostcodeResultDetail, index: number) => {
        if (this.state.model.addressIndex != index) {
            let newModel: AddressSelectorViewModel = this.state.model;
            newModel.addressIndex = index;
            newModel.address1 = address.Property + " " + address.Street
            newModel.address2 = '';
            newModel.address3 = address.Town;
            newModel.address4 = address.OptionalCounty;

            this.setState({ model: newModel }, () => this.props.setAddress(newModel));
        }
    }
}

export default withStyles(styles)(Address);